import React from "react";

const WorstPain = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_939_535)">
                <circle cx="24" cy="24" r="23" fill="white" />
                <path
                    d="M24.0401 47.9906C11.4841 48.3657 -0.0767952 37.8974 -0.000108905 24.0609C0.0765774 10.4345 10.4928 0.0374859 23.9541 -2.14557e-05C37.275 -0.0375288 48.1065 10.4158 47.998 24.226C47.8877 38.1918 36.4876 48.2907 24.0401 47.9906ZM24.0233 45.9596C36.0985 46.1227 46.1501 36.4777 45.9649 23.8134C45.7779 10.7833 35.6422 2.00475 23.8362 2.00099C20.9516 2.00306 18.096 2.57841 15.4345 3.69377C12.7729 4.80913 10.3583 6.44238 8.33016 8.49911C6.30202 10.5558 4.70058 12.9952 3.61843 15.6763C2.53628 18.3574 1.99488 21.2269 2.02553 24.1191C2.05359 36.6878 12.135 46.1865 24.0233 45.9596Z"
                    fill="black"
                />
                <path
                    d="M31.187 33.8447C30.8971 35.0656 30.6933 35.9245 30.4389 37.0329C24.5228 34.6511 19.2539 36.414 14.3441 39.4708C13.5118 38.8857 13.7475 38.3456 14.0467 37.8393C15.2999 35.6864 17.1665 34.1917 19.3792 33.1865C22.6636 31.6956 26.0453 31.4987 29.4345 32.8921C30.0106 33.1227 30.5436 33.4884 31.187 33.8447Z"
                    fill="black"
                />
                <path
                    d="M35.0438 29.6814C37.0881 31.8906 37.9934 34.3604 38.6256 36.9166C39.0203 38.5125 38.3226 39.8496 36.989 40.7892C36.4167 41.2088 35.7268 41.4365 35.0178 41.4398C34.3088 41.4432 33.6169 41.2221 33.0406 40.8079C31.7575 39.934 31.3572 38.7094 31.5443 37.1697C31.881 34.3679 33.0743 31.9993 35.0438 29.6814Z"
                    fill="black"
                />
                <path
                    d="M35.0962 28.3912C32.2625 28.4268 29.5093 26.3564 28.8808 23.6559C28.7572 23.093 28.7445 22.5114 28.8434 21.9437C28.9688 21.2142 29.4588 20.7941 30.2575 20.8747C30.5882 20.883 30.9172 20.9251 31.2394 21.0004C33.7682 21.8049 36.1679 22.902 38.3301 24.4548C39.5702 25.3456 39.5608 25.942 38.4386 27.0447C37.509 27.958 36.4111 28.4456 35.0962 28.3912Z"
                    fill="black"
                />
                <path
                    d="M13.0349 28.393C11.417 28.498 10.1769 27.7817 9.15384 26.5964C8.64135 26.0001 8.63386 25.4093 9.19311 24.8411C9.42317 24.6067 9.64762 24.3272 9.94127 24.1903C12.1633 23.1232 14.3498 21.9586 16.6448 21.0828C18.4665 20.3871 19.6599 21.6455 19.2091 23.549C18.5619 26.2326 15.8237 28.3836 13.0349 28.393Z"
                    fill="black"
                />
                <path
                    d="M29.5 17.3378L30.7064 16.2894C32.5363 18.0942 34.7301 19.4856 37.1406 20.3702C38.289 20.7828 39.4954 21.0379 40.6756 21.3567C40.8327 21.3998 41.0067 21.3773 41.1675 21.4129C41.8166 21.5517 42.2898 21.9624 42.0448 22.6075C41.9288 22.9151 41.2629 23.2377 40.8963 23.187C39.7608 23.0506 38.6433 22.7916 37.5633 22.4144C34.6249 21.3285 31.8081 20.0195 29.5 17.3378Z"
                    fill="black"
                />
                <path
                    d="M17.391 15.6105L18.3393 16.4901C18.2009 16.9983 18.2065 17.199 18.1111 17.3002C15.1559 20.419 11.3665 21.9099 7.2946 22.8176C6.66802 22.9582 6.06949 22.7482 5.92734 22.0806C5.77771 21.3829 6.2771 21.0472 6.92052 20.9291C7.64436 20.7978 8.37756 20.7022 9.08831 20.524C12.1913 19.7513 14.8884 18.2398 17.391 15.6105Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_939_535">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default WorstPain;
